import * as types from './types';

const initialState = {
  paging: { total: undefined, offset: 0, limit: 0 },
  leads: [],
  loading: '',
  updateMobile: false,
  sorted: { value: 'last_activity' },
  params: {
    limit: 10,
    offset: 0
  }
};

const MessageSeekerReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_SEEKER_LEADS:
      state.loading = 'loading';
      state.leads = [];
      return { ...state };
    case types.FETCH_SEEKER_LEADS_SUCCEEDED:
      state.loading = 'loaded';
      state.leads = action.payload.result;
      state.paging = action.payload.paging;
      return { ...state };
    case types.FETCH_SEEKER_LEADS_FAILED:
      state.loading = 'error';
      return { ...state };

    case types.FETCH_SEEKER_LEADS_SUCCEEDED_MOBILE:
      state.loading = 'loading';
      if (action.payload.result) {
        if (state.updateMobile === true && action.payload.result.length >= 10) {
          state.updateMobile = false;
          state.loading = 'loading';
        }
        state.paging = action.payload.paging;
        const newData = [];
        action.payload.result.forEach(d => {
          newData.push(d);
        });
        state.leads = [...state.leads, ...newData];
      }

      state.updateMobile = true;
      state.loading = 'loaded';
      return { ...state };

    case types.FETCH_SEEKER_LEADS_MOBILE:
      state.loading = 'loading';
      state.updateMobile = false;
      return { ...state };

    case types.SET_SEEKER_LEADS_ORDER:
      state.sorted = action.payload;
      return { ...state };

    case types.SET_SEEKER_LEADS_OFSET:
      state.paging.offset = action.payload;
      return { ...state };

    case types.FETCH_SEEKER_MOBILE_SUCCEEDED_UPDATE_EVENT:
      return { ...state, loading: 'loading', updateMobile: true };

    case types.FETCH_SEEKER_LEADS_SUCCEEDED_MOBILE_SORTED:
      state.loading = 'loaded';
      state.leads = action.payload.result;
      state.paging = action.payload.paging;
      state.updateMobile = true;
      return { ...state };

    default:
      return { ...state };
  }
};

export default MessageSeekerReducer;
